/* eslint-disable import/no-cycle */
import Cookie from 'js-cookie';
import { getDomain, isLocalhost, isEmbedded } from './stringUtils';

export const getCookie = name => Cookie.get(name);
export const setCookie = (name, value, options = {}) =>
  Cookie.set(name, value, {
    secure: !isLocalhost,
    sameSite: isEmbedded() ? 'none' : isLocalhost ? 'lax' : 'strict',
    domain: getDomain(),
    ...options,
  });
